<div
  class="flex h-full min-h-[70px] cursor-pointer items-center justify-between gap-4 p-4 hover:bg-pl-black"
  [ngClass]="backgroundColor"
>
  <div class="flex justify-center">
    <pl-icon *ngIf="iconLeft" [name]="iconLeft" class="h-6 w-6" [ngClass]="iconLeftColor" />
  </div>
  <div [ngClass]="{ '!text-pl-gray-400': isLocked }" class="flex grow flex-col justify-center text-white">
    <h2 *ngIf="title" class="font-normal">{{ title }}</h2>
    <p *ngIf="subtitle" class="text-sm uppercase" [ngClass]="orangeSubtitle ? 'text-pl-orange-600' : 'text-inherit'">
      {{ subtitle }}
    </p>
    <p *ngIf="description" class="text-base text-inherit">{{ description }}</p>
  </div>
  <pl-icon *ngIf="iconRight" class="h-5 w-5 min-w-[1.25rem]" [name]="iconRight" />
</div>
